import React from 'react';

const ABOUT_ME_MAX_CHARS = 2000;

interface AboutMeEditorProps {
  value: string;
  onChange: (value: string) => void;
  isLoading: boolean;
}

export const AboutMeEditor: React.FC<AboutMeEditorProps> = ({ value, onChange, isLoading }) => {
  const charCount = value.length;
  const isOverLimit = charCount > ABOUT_ME_MAX_CHARS;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        About Me
      </label>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
        Tell the AI assistant about yourself — your role, preferences, working style, or anything
        that helps it assist you better. This is included in every conversation.
      </p>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLoading}
        rows={6}
        maxLength={ABOUT_ME_MAX_CHARS}
        placeholder="e.g. I'm a software engineer. I prefer concise answers. I work Mon-Fri 9am-5pm GMT. My current focus is launching v2 of our product..."
        className="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-vertical disabled:opacity-50"
      />
      <div className={`text-xs mt-1 text-right ${isOverLimit ? 'text-red-500' : 'text-gray-400 dark:text-gray-500'}`}>
        {charCount} / {ABOUT_ME_MAX_CHARS}
      </div>
    </div>
  );
};
